var $loader = $('.c-loading');

//show/hide loader on click
$loader.addClass('c-loading--hide');

function showLoadingPanel() {
  $loader.addClass('c-loading--show');
  $loader.removeClass('c-loading--hide');
}

function hideLoadingPanel() {
  $loader.addClass('c-loading--hide');
}